<template>
  <div>
    <span v-for="(er, er1) in errors" :key="er1">{{ er }}</span>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="lead text-white mt-4 mb-5">
          Select Country to Build your own package.
        </p>
        <div class="countryselect-wrapper">
          <multiselect
            :multiple="true"
            placeholder="Select atleast one country"
            v-model="form.Country"
            :options="options"
          ></multiselect>
        </div>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="lead text-white mt-4 mb-5">
          Select city
        </p>
        <div class="countryselect-wrapper">
          <multiselect
            :multiple="true"
            placeholder="Select atleast one City"
            v-model="form.city"
            :options="cityoptions"
          ></multiselect>
        </div>
      </div>
    </div>
    <p class="white">or Dont know where to go yet? Click here</p>
  </div>
</template>

<script>
//   import Multiselect from 'vue-multiselect'

// register globally
//Vue.component('multiselect', Multiselect)

export default {
  // OR register locally
  name: "CountrySelect",
  components: {},
  data() {
    return {
      value: null,
      cityvalue:null,
      options: ["India", "USA", "Singapore"],
      cityoptions: [
        {"India":"Mumba"}, {"India":"Delhi"}, {"India":"Bangalore"},{"India":"Hyderabad"},
        {"USA":"New York","USA":"Los Angeles","USA":"Chicago","USA":"Houston"},
        {"singapore":"Bukit Timah","singapore":"Changi","singapore":"Choa Chu Kang","singapore":"Clementi"}
        ],
      errors: [],
      form: {
        Country: null,
        city:null
      },
    };
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
